import React from "react";
import { Container, Row, Col } from "reactstrap";

// The studio's shipped titles. Each card is a doorway to that title's own
// world — the studio site stays about the studio; platform specifics
// (pricing, creator onboarding) live on each title's site.
const titles = [
  {
    name: "Morph",
    tagline: "How you market.",
    logo: require("assets/img/Morph_logo_mint.png"),
    // Square mark — give it real height so it holds its own next to the
    // wide ARCADE wordmark.
    logoStyle: { height: 140, maxWidth: "100%", objectFit: "contain" },
    blurb:
      "Augmented reality for artists and brands: portals your audience can " +
      "step inside, art they can place on their floor, table, or wall, and " +
      "collectable cards that unlock what only their holders can see.",
    links: [
      { text: "Get the app", href: "http://l.ead.me/morph", primary: true },
      { text: "Creator studio", href: "https://morphxr.app" }
    ]
  },
  {
    name: "A.R.C.A.D.E.",
    tagline: "Unleash the GameAR inside.",
    logo: require("assets/img/ArcadeRed.png"),
    // Wide wordmark — cap by WIDTH, never intrinsic size, and center it in
    // the same 140px band so both cards' logos occupy equal space.
    logoStyle: { maxWidth: "80%", height: 140, objectFit: "contain" },
    blurb:
      "Augmented reality arcade gaming: real-world play, classic arcade " +
      "energy, and world leaderboards — your room is the cabinet.",
    links: [{ text: "ararcade.app", href: "https://ararcade.app", primary: true }]
  },
  {
    name: "ROY G. BIV",
    tagline: "A story told in tapes.",
    logo: require("assets/img/ROYGBIV_logo.jpg"),
    // Square app icon — same treatment as the Morph mark.
    logoStyle: { height: 140, maxWidth: "100%", objectFit: "contain" },
    blurb:
      "A narrative video game told in episodic tapes — explore each level's " +
      "world and chase its leaderboards. Three tapes are out now, with new " +
      "levels on the way.",
    links: [
      {
        text: "Get the app",
        href: "https://apps.apple.com/us/app/the-roy-g-biv-tape-series/id1450906125",
        primary: true
      }
    ]
  }
];

const Titles = () => {
  return (
    <section className="section" id="titles">
      <Container>
        <div className="section-heading text-center">
          <h2 className="heading-line">Our titles</h2>
        </div>

        <Row className="justify-content-center">
          {titles.map((title, i) => (
            <Col md="6" lg="4" key={i} className="mb-5 mb-lg-0">
              {/* position/zIndex: keep the card and its buttons above the
                  theme's decorative shape/bubble layers, which otherwise
                  overlap and swallow clicks. overflow hidden so a logo can
                  never bleed past the card edge again. */}
              <div
                className="card shadow border-0 text-center p-4 p-md-5 h-100"
                style={{ position: "relative", zIndex: 10, overflow: "hidden" }}
              >
                <div
                  className="d-flex align-items-center justify-content-center mb-4"
                  style={{ height: 140 }}
                >
                  <img
                    src={title.logo}
                    alt={`${title.name} logo`}
                    style={title.logoStyle}
                    className="d-block"
                  />
                </div>
                <h3 className="bold">{title.name}</h3>
                <p className="lead bold mb-2">{title.tagline}</p>
                <p className="text-muted flex-grow-1">{title.blurb}</p>
                <nav className="nav justify-content-center flex-wrap">
                  {title.links.map((link, j) => (
                    <a
                      key={j}
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`btn btn-rounded my-2 mx-2 btn-${
                        link.primary ? "primary text-contrast" : "alternate"
                      }`}
                    >
                      {link.text}
                    </a>
                  ))}
                </nav>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Titles;
